var projektsida = (function () {
  var mediablock;

  /* ********** Exponerade funktioner     */
  function initProjektsidaMedia() {
    mediablock = document.getElementById("mediablock");

    if (mediablock) {
      var modal = mediablock.querySelector(".modal");
      var carousel = modal.querySelector(".carousel");

      mediablock
        .querySelectorAll(
          ".js-videoblock-projektsida, .js-bildblock-projektsida, .js-memento360block"
        )
        .forEach(function (elem) {
          elem.addEventListener("click", function (event) {
            if (window.innerWidth > window.smMax) {
              event.preventDefault();
              let target = event.currentTarget;
              let mediablockItem = target.closest(".mediablockitem");
              let ancestorId = mediablockItem.id;
              let nr = ancestorId.substring(ancestorId.indexOf("_") + 1);
              let activeItem = modal.querySelector("#carouselitem_" + nr);
              activeItem.classList.add("active");

              let modalbtn = mediablock.querySelector(".js-mediamodal-btn");
              modalbtn.click();
            }
          });
        });

      modal.addEventListener("shown.bs.modal", function () {
        let activeItem = carousel.querySelector(".carousel-item.active");
        if (activeItem.querySelector(".videoblock")) {
          let videoBlock = activeItem.querySelector(".videoblock");
          videoBlock.querySelector(".videolink").click();
        }
      });

      carousel.addEventListener("slid.bs.carousel", function (event) {
        event.target
          .querySelectorAll(".carousel-item:not(.active)")
          .forEach(function (item) {
            if (item.querySelector(".videoblock")) {
              item.querySelector(".videolink").classList.remove("d-none");
              if (item.querySelector("iframe")) {
                item.querySelector("iframe").remove();
              } else if (item.parentElement.querySelector(".mediaflow-video")) {
                item.parentElement.querySelector(".mediaflow-video").remove();
              }
            }
          });
      });

      modal.addEventListener("hide.bs.modal", function (event) {
        event.target.querySelectorAll(".videoblock").forEach(function (item) {
          item.querySelector(".videolink").classList.remove("d-none");
          if (item.querySelector("iframe")) {
            item.querySelector("iframe").remove();
          } else if (item.parentElement.querySelector(".mediaflow-video")) {
            item.parentElement.querySelector(".mediaflow-video").remove();
          }
        });
      });

      modal.addEventListener("hidden.bs.modal", function (event) {
        event.target
          .querySelectorAll(".carousel-item")
          .forEach(function (item) {
            item.classList.remove("active");
          });
      });
    }
  }

  function initSocialLinks() {
    document.querySelectorAll(".js-social-sharing").forEach(function (elem) {
      elem.addEventListener("click", function (event) {
        event.preventDefault();
        let href = elem.href;
        window.open(
          href,
          "popup",
          "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600"
        );
      });
    });
  }

  function initProjektsida() {
    initProjektsidaMedia();
    initSocialLinks();
  }

  /* ********** Returnera exponerat gränssnitt     */
  return {
    initProjektsida: initProjektsida,
  };
})();

export default projektsida;
